import React from 'react'
import { useStyles } from './styles'
import { Box, Drawer, IconButton } from '@mui/material'
import { QualificationCard } from '../qualificationCard'
import { ExecutionCard } from '../executionCard'
import { icons } from '../../../../../../utils/icons'
import { InformationProps } from './types'
import { QualificationCardProps } from '../qualificationCard/types'
import { ExecutionCardProps } from '../executionCard/types'
import { Hidden } from '@material-ui/core'

export const Information = ({drawer, closeDrawer, t, list}:InformationProps) => {
    const styles = useStyles()
    
  return (
    <>
    <Box sx={styles.bigScreens}>
        {list?.map(card => {
          if (!!(card as QualificationCardProps)?.qualification || (card as QualificationCardProps)?.qualification==0) { return <QualificationCard {...card as QualificationCardProps} margin /> }
          return <ExecutionCard {...card as ExecutionCardProps} margin />
        })}
    </Box>
    <Hidden lgUp>
      <Box sx={styles.smallScreens}>
        <Drawer {...drawer} anchor="right" PaperProps={{ style: { padding: '20px'} }}>
          <Box sx={styles.close}>
            <IconButton onClick={closeDrawer} sx={{ marginRight:'-10px'}}>{icons('simple-close')}</IconButton>
          </Box>
            {list?.map(card => {
              if (!!(card as QualificationCardProps)?.qualification || (card as QualificationCardProps)?.qualification==0) { return <QualificationCard {...card as QualificationCardProps}/> }
              return <ExecutionCard {...card as ExecutionCardProps}/>
            })}
        </Drawer>
      </Box>
    </Hidden>
    </>

  )
}
